"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = exports.Action = void 0;
exports.reducer = reducer;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const constructors_union_1 = require("@genesys/client-core/lib/constructors-union");
exports.Action = (0, constructors_union_1.ctorsUnion)({
    SystemTypePropertySearchSetSettings: (settings) => ({ settings }),
    SystemTypePropertySearchToggleLoader: () => ({}),
    SystemTypePropertySearchSetResult: (messages) => ({
        messages
    })
});
exports.initialState = {
    loading: false,
    settings: {
        systemTypeId: undefined,
        propertyName: undefined
    },
    messages: []
};
// biome-ignore lint: -
function reducer(state = exports.initialState, action) {
    switch (action.type) {
        case "SystemTypePropertySearchSetSettings": {
            return Object.assign(Object.assign({}, state), { settings: action.settings });
        }
        case "SystemTypePropertySearchToggleLoader": {
            return Object.assign(Object.assign({}, state), { loading: !state.loading });
        }
        case "SystemTypePropertySearchSetResult": {
            return Object.assign(Object.assign({}, state), { loading: false, messages: action.messages });
        }
        default: {
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
        }
    }
    return state;
}
//# sourceMappingURL=system-type-property-search-state.js.map